import { COMMUNITY_MEMBER_ROLES } from "@utils/constants";
import getYouTubeID from "get-youtube-id";

export const getViewerRole = (role) => {
  /* return "joined" or "requested" */
  if (!role) return null;

  if (role === COMMUNITY_MEMBER_ROLES.INVITED) return null;

  if (role === COMMUNITY_MEMBER_ROLES.REQUESTED) return "requested";

  return "joined";
};



export const getYTVideoThumbnailLink = (url) => {
  const videoID = getYouTubeID(url, { fuzzy: false });

  return `https://i.ytimg.com/vi_webp/${videoID}/0.webp`;
};
